import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import DocumentTypeList from "../../Sections/DocumentType";

const DocumentComponent = () => {
    return (
        <Dashboard sectionName={<DocumentTypeList/>}/>
    );
};

export default DocumentComponent;